import * as appActions from '@bca-store/app.actions';
import { AppActionTypes } from '@bca-store/app.actions';
import { IMessage } from '@bca-shared/models/message';
import { Route } from '@bca-shared/models/_enums';
import { DialogId } from '@bca-shared/models/_types';

export const INITIAL_STATE: IState = {
  currentRoute: Route.COMPOSE,
  showPhone: false,
  lastMessage: null,
  highestRoute: Route.COMPOSE,
  dialogStatus: Object()
};

export interface IState {
  readonly currentRoute: Route;
  readonly showPhone: boolean;
  readonly lastMessage: IMessage;
  readonly highestRoute: Route;
  readonly dialogStatus: { [key in DialogId]?: boolean };
}

export function reducer(state: IState = INITIAL_STATE, action: appActions.Action): IState {
  switch (action.type) {
    case AppActionTypes.ShowPhone: {
      return {
        ...state,
        showPhone: true
      };
    }
    case AppActionTypes.CloseDialogs: {
      return {
        ...state,
        dialogStatus: Object()
      };
    }
    case AppActionTypes.SetDialogStatus: {
      const { visible, identifier } = action.payload;
    
      return {
        ...state,
        dialogStatus: visible
          ? { [identifier]: true }
          : {},
      };
    }
    case AppActionTypes.SetRoute: {
      const { route: currentRoute } = action.payload;
      return {
        ...state,
        currentRoute: currentRoute === Route.ISSUER ? Route.CONFIRMATION : currentRoute
      };
    }
    case AppActionTypes.SetHighestRoute: {
      const { route: highestRoute } = action.payload;
      return {
        ...state,
        highestRoute
      };
    }
    case AppActionTypes.SetMessage: {
      return {
        ...state,
        lastMessage: action.payload
      };
    }
    case AppActionTypes.DeleteMessage: {
      return {
        ...state,
        lastMessage: null
      };
    }
  }

  return state;
}
